import React, { useState } from "react";
import { Button, Space, Typography } from "antd";
import { SettingOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import PageHeader from "./common/PageHeader";
import DataTable from "./common/DataTable";
import { listConfigs } from "../network/api";
import { relativeTime } from "../constants/health";
import { notify } from "../utils/notify";
import AddConfig from "./Modals/addConfig";

const { Text } = Typography;

const Configs = () => {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);
  // Bump to force DataTable to refetch after a config is created.
  const [refreshKey, setRefreshKey] = useState(0);

  const columns = [
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      sorter: true,
      render: (title) => <Text strong>{title || "—"}</Text>,
    },
    {
      title: "Picture Freq.",
      dataIndex: "pictureFrequency",
      key: "pictureFrequency",
      sorter: true,
      render: (v) => (v != null ? `${v}s` : <Text type="secondary">—</Text>),
    },
    {
      title: "Upload Freq.",
      dataIndex: "uploadFrequency",
      key: "uploadFrequency",
      sorter: true,
      render: (v) => (v != null ? `${v}s` : <Text type="secondary">—</Text>),
    },
    {
      title: "Resolution",
      dataIndex: "resolution",
      key: "resolution",
      render: (v) => v || <Text type="secondary">—</Text>,
    },
    {
      title: "Rotation",
      dataIndex: "rotation",
      key: "rotation",
      render: (v) => (v != null && v !== "" ? `${v}°` : <Text type="secondary">—</Text>),
    },
    {
      title: "Updated",
      dataIndex: "updatedAt",
      key: "updatedAt",
      sorter: true,
      render: (value) => relativeTime(value),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Space size="small" onClick={(e) => e.stopPropagation()}>
          <Button
            type="link"
            size="small"
            icon={<EditOutlined />}
            onClick={() => navigate(`/dashboard/config-details/${record._id}`)}
          >
            Edit
          </Button>
        </Space>
      ),
    },
  ];

  const handleCreated = () => {
    notify.success("Config added successfully!");
    setRefreshKey((k) => k + 1);
  };

  return (
    <div>
      <PageHeader
        title="Configurations"
        subtitle="Capture & upload profiles assigned to devices"
        icon={<SettingOutlined style={{ fontSize: 22, color: "#2f54eb" }} />}
        extra={
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => setVisible(true)}
          >
            Add Config
          </Button>
        }
      />

      <DataTable
        fetcher={listConfigs}
        rowKey="_id"
        columns={columns}
        refreshKey={refreshKey}
        searchPlaceholder="Search configurations…"
        scrollX={1000}
        emptyText="No configurations found"
        onRow={(record) => ({
          style: { cursor: "pointer" },
          onClick: () => navigate(`/dashboard/config-details/${record._id}`),
        })}
      />

      <AddConfig
        visible={visible}
        onSubmit={handleCreated}
        onClose={() => setVisible(false)}
      />
    </div>
  );
};

export default Configs;
